import Repository from '@/services/Repository';
import TokenService from '../helpers/token';

const resource = `${Repository.defaults.tutorSortUrl}/`;
const careResource = `${Repository.defaults.apiURL}`;
const resourceCrm = `${Repository.defaults.erpUrl}`;
const classinResource = `${Repository.defaults.tutorClassin}`;
export default {
  async getListSchedules(params = {}) {
    const response = await Repository.get(`${resource}v2/class-schedule`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getSortClassInfo(id) {
    const response = await Repository.get(`${careResource}/routine-student/sort-class-info?id=${id}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getStudentInfo(id) {
    const response = await Repository.get(`${resource}students?studentProductsId=${id}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getListTeachers(payload = {}) {
    const response = await Repository.post(`${resource}v2/class/teachers`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async changeOperator(payload) {
    const response = await Repository.post(`${resource}assignment-department/assign-to-operator`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async storeClass2(payload = {}) {
    const response = await Repository.post(`${resource}v2/classroom`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async updateCareTag(payload) {
    const response = await Repository.put(`${careResource}/care-tag/update`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async createClassinClass(payload) {
    const response = await Repository.post(`${classinResource}/class-in/create-course`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async addMultipleStudent(payload) {
    const response = await Repository.post(`${classinResource}/class-in/add-multiple-student-in-course`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getListProduct(id, params = {}) {
    const response = await Repository.get(`${resource}students/${id}/products`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getListCities(params) {
    const response = await Repository.get(`${resource}cities`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getDetailStudent(id, params = {}) {
    const response = await Repository.get(`${resource}students/${id}`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getDataFilter(subjectId, classType) {
    // eslint-disable-next-line no-return-await
    return await Repository.get(`${resource}classes/subject/${subjectId}/empty/filters?typeCurriculum=online&classType=${classType}`, {
      headers: TokenService.getHeader(),
    });
  },
  async getListEmptySlotClass(subjectId, params) {
    const response = await Repository.get(`${resource}classes/subjects/${subjectId}/empty`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getInfoClass(id, idProduct) {
    const response = await Repository.get(`${resource}students/${id}/products/${idProduct}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getLessonWaiting(id, isEdit) {
    const params = {};
    if (isEdit) {
      params.isEdit = true;
    }
    // eslint-disable-next-line no-return-await
    return await Repository.get(`${resource}classes/${id}/suggest`, {
      params,
      headers: TokenService.getHeader(),
    });
  },
  async addStudentInClassEmpty(classId, body) {
    const response = await Repository.post(`${resource}classes/${classId}/students`, body, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getEmptySchedules(studentId, params = {}) {
    const response = await Repository.get(`${resourceCrm}/tutor-student-class/${studentId}/calendars`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async updateEmptySchedules(studentId, body) {
    const response = await Repository.post(`${resourceCrm}/tutor-student-class/${studentId}/calendars`, body, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async updateStudentClass(studentProductId, body) {
    const response = await Repository.put(`${resource}students/grade/${studentProductId}`, body, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
};
